import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
  to?: string;
  icon?: string;
  text: string;
  onClick?: () => void;
}

export const BurgerAuthButton: FC<Props> = ({ to, icon, text, onClick }) => {
  if (to) {
    return (
      <StyledLink className='flex' to={to} onClick={onClick}>
        <IconWrapper src={icon}/>
        <Text>{text}</Text>
      </StyledLink>
    );
  }
  return (
    <StyledButton className='flex' onClick={onClick}>
      <IconWrapper src={icon}/>
      <Text>{text}</Text>
    </StyledButton>
  );
};

const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 8px;
    height: 56px;
    flex: 1;
    background-color: rgba(255, 255, 255, 0.1);
`;

const StyledButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    gap: 8px;
    height: 56px;
    flex: 1;
    background-color: rgba(255, 255, 255, 0.1);
    border: none;
    cursor: pointer;
    padding: 0;
`;

const IconWrapper = styled.img`
    height: 20px;
    width: 20px;
`;

const Text = styled.p`
    color: white;
    font-weight: 600;
    font-size: 16px;
    text-decoration: none;
`;
